// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import CloseIcon from '../../assets/close.svg';
import Arrow from '../../assets/arrow.svg';
const S = {
  Container: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(49, 49, 49, 0.71);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  PopupBox: styled.div`
    padding: 48px 24px 32px 36px;
    display: flex;
    width: 1027px;
    height: 580px;
    background: #FFFFFF;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    position: relative;
    justify-content: center;
  `,
  CloseButton: styled.img.attrs({ src: CloseIcon })`
    position: absolute;
    height: 20px;
    width: 20px;
    top: 26px;
    right: 26px;
    cursor: pointer;
  `,
  BodyWrapper: styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
  `,
  LeftSideWrapper: styled.div`
    flex: 1 1 259px;
    padding-right: 19px;
    display: flex;
    flex-direction: column;
    border-right: 3px solid #EFEFEF;
    flex-grow: 1;
    height: 100%;
  `,
  Username: styled.div`
    font-weight: bold;
    font-size: 18px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: #434343;
    flex: none;
    margin-bottom: 16px;
  `,
  Time: styled.div`
    font-size: 14px;
    line-height: 14px;
    display: flex;
    align-items: center;
    color: #848484;
    flex: none;
    margin-bottom: 30px;
  `,
  Message: styled.div`
    display: flex;
    font-size: 16px;
    line-height: 23px;
    color: #434343;
    overflow: auto;
    word-break: break-all;
  `,
  RightSideWrapper: styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    height: 100%;
    padding: 17px 0 0 18px;
    justify-content: center;
    align-items: center;
  `,
  ArrowLeft: styled.img.attrs({ src: Arrow })`
    flex-shrink: 0;
    margin-right: 24px;
    cursor: pointer;
  `,
  ImageWrapper: styled.div`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  `,
  ArrowRight: styled.img.attrs({ src: Arrow })`
    flex-shrink: 0;
    margin-left: 24px;
    transform: rotate(180deg);
    cursor: pointer;
  `,
  ImagePreview: styled.img`
    width: 594px;
    height: 415px;
    object-fit: scale-down;
  `,
  ImageListItem: styled.img`
    width: 77px;
    height: 60px;
    flex-shrink: 0;
    object-fit: cover;
    margin-right: 8px;
    cursor: zoom-in;
  `,
  ImageListWrapper: styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 8px;
  `,
};

export { S as default };
